<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract?.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract?.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          BẢO VỆ DỮ LIỆU CÁ NHÂN
        </b>
      </p>
      <p class="txt-center">
        (PLBVDLCN số:
        <mark>01</mark>
        )
      </p>
      <!-- <p class="txt-center">
        (PLBVDLCN số:
        <mark>01</mark>
        )
      </p> -->
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li v-if="!checkCreatedDateNganluong(dataAppendix)">
          Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15;
        </li>
        <li v-if="!checkCreatedDateNganluong(dataAppendix)">
          Nghị định 356/2025/NĐ-CP được ban hành để hướng dẫn chi tiết Luật Bảo vệ dữ liệu cá nhân
          số 91/2025/QH15,
        </li>
        <li v-if="checkCreatedDateNganluong(dataAppendix)">
          Căn cứ Nghị định số 13/2023/NĐ-CP ngày 17/4/2023,
        </li>
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán thẻ số:
          <mark>{{ dataContract.code }}</mark> (sau đây được viết tắt là “Hợp đồng”) ký ngày
          <mark>{{ dataContract.effectiveFromDTO | formatDate }}</mark>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>

      <p>
        Hôm nay, ngày
        <mark>{{ dataContract.effectiveFromDTO | formatDate }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>
      <p>cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>

      <ol class="form-style1">
        <li>
          <h1>NHỮNG QUY ĐỊNH CHUNG</h1>
          <ol>
            <li>
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              đề cao và tôn trọng quyền riêng tư, bảo mật và an toàn thông tin cá nhân. Đồng thời,
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              luôn nỗ lực bảo vệ thông tin cá nhân, quyền riêng tư của Bên B (bao gồm cả những chủ
              thể có liên quan của Bên B) và tuân thủ quy định pháp luật Việt Nam thông qua những
              biện pháp bảo vệ dữ liệu cá nhân đáp ứng và phù hợp với các tiêu chuẩn quốc tế.
            </li>
            <li>
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              chỉ thu thập, xử lý và lưu trữ dữ liệu cá nhân của Bên B phù hợp với quy định của pháp
              luật và trong phạm vi (các) thỏa thuận giữa
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              và Bên B.
            </li>
            <li>
              Bằng việc tự mình hoặc nhân danh Công ty thực hiện việc cung cấp dữ liệu cá nhân của
              một bên thứ ba (bao gồm nhưng không giới hạn bởi: các cá nhân có liên quan của Công
              ty, chủ sở hữu, người tham chiếu, bên thụ hưởng, người được ủy quyền, đối tác, người
              liên hệ hoặc cá nhân khác của Bên B hoặc Công ty) cho
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}, Bên B cam
              đoan, bảo đảm và chịu trách nhiệm rằng Bên B đã có được sự đồng ý hợp pháp của bên thứ
              ba đó cho việc xử lý và thông tin về việc
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              là chủ thể xử lý các thông tin cá nhân cho các mục đích được nêu tại Điều khoản và
              điều kiện chung về Bảo vệ dữ liệu cá nhân.
            </li>
            <li>
              Phụ thuộc vào vai trò của
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              trong từng tình huống cụ thể là (i) Bên Kiểm soát dữ liệu cá nhân; (ii) Bên Xử lý dữ
              liệu cá nhân; hoặc (iii) Bên Kiểm soát và xử lý dữ liệu,
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              sẽ thực hiện các quyền hạn và trách nhiệm tương ứng theo quy định của pháp luật hiện
              hành.
            </li>
          </ol>
        </li>
        <li>
          <h1>GIẢI THÍCH TỪ NGỮ</h1>
          <ol>
            <li>
              <b>“Chủ thể dữ liệu”</b> là cá nhân được dữ liệu cá nhân phản ánh, bao gồm tất cả các
              khách hàng đăng ký tìm hiểu, hoặc đang sử dụng Sản Phẩm, Dịch Vụ, người dùng các nền
              tảng số của {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }},
              người lao động, cộng tác viên, ứng viên tiềm năng, cổ đông, các cá nhân khác có liên
              quan hoặc phát sinh từ quan hệ sử dụng, cung cấp Sản Phẩm, Dịch Vụ hoặc quan hệ pháp
              lý khác với {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}.
            </li>
            <li>
              <b>“Bên cung cấp dữ liệu cá nhân”</b> (gọi tắt là <b>“Bên cung cấp”</b>) là các cá
              nhân, tổ chức thay mặt hoặc được sự đồng ý của cá nhân là Bên B để cung cấp Dữ liệu cá
              nhân của cá nhân đó cho
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}.
            </li>
            <li>
              <b>“Khách hàng”</b> bao gồm cá nhân, tổ chức hiện hữu hoặc tiềm năng của
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}. Là người mua
              hàng hoặc sử dụng dịch vụ, có thể là người tiêu dùng cá nhân, tổ chức phi lợi nhuận,
              tổ chức kinh doanh, chính phủ hoặc bất kỳ ai có nhu cầu sử dụng Sản Phẩm, Dịch Vụ mà
              {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
              cung cấp.
            </li>
            <li>
              <b>“Dữ liệu cá nhân”</b> là thông tin dưới dạng ký hiệu, chữ viết, chữ số, hình ảnh,
              âm thanh hoặc dạng tương tự trên môi trường điện tử gắn liền với một con người cụ thể
              hoặc giúp xác định một con người cụ thể. Dữ liệu cá nhân bao gồm dữ liệu cá nhân cơ
              bản và dữ liệu cá nhân nhạy cảm.
            </li>
            <li>
              <b>“Dữ liệu cá nhân cơ bản”</b> bao gồm: Họ tên, ngày, tháng, năm sinh, giới tính,
              quốc tịch, số điện thoại; hình ảnh cá nhân; thông tin có được từ các hệ thống an ninh,
              kể cả bản ghi âm, ghi lại hình ảnh của Bên B trên hệ thống máy quay, camera giám sát
              tại các địa điểm giao dịch của Bên A; Thông tin được thu thập tự động khi Bên B sử
              dụng Sản Phẩm, Dịch Vụ, hoặc website, ứng dụng trên thiết bị di động và các phương
              tiện liên lạc khác của Bên A như địa chỉ IP, mã thiết bị, loại thiết bị, hệ điều hành,
              loại trình duyệt, ngày giờ kết nối, cookie(s), … và các thông tin kỹ thuật khác; Thông
              tin/dữ liệu được tạo lập từ kết quả vận hành tài khoản thanh toán/thẻ hoặc tài khoản
              thẻ, dữ liệu về cách thức Bên B quản lý và sử dụng tài khoản thanh toán/thẻ; hành vi,
              hành động, hoặc sở thích của Bên B được thể hiện trên các nền tảng số; và các thông
              tin khác theo quy định pháp luật.
            </li>
            <li>
              <b>“Dữ liệu cá nhân nhạy cảm”</b> là dữ liệu cá nhân gắn liền với quyền riêng tư của
              cá nhân mà khi bị xâm phạm sẽ gây ảnh hưởng trực tiếp tới quyền và lợi ích hợp pháp
              của cá nhân, bao gồm các thông tin theo quy định pháp luật và:
              <ul>
                <li>
                  Thông tin khách hàng tại
                  {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}, gồm: thông
                  tin định danh khách hàng theo quy định pháp luật, thông tin về tài khoản (bao gồm
                  cả tài khoản riêng hay đồng sở hữu với bất kỳ bên nào khác), thông tin về giao
                  dịch (bao gồm cả tần suất, giá trị giao dịch, mục đích giao dịch, thời gian duy
                  trì quan hệ với Bên A, Sản Phẩm, Dịch Vụ thường xuyên sử dụng), thông tin cá nhân,
                  tổ chức có liên quan đến khách hàng tại
                  {{ checkCreatedDateNganluong(dataAppendix) ? 'Ngân Lượng' : 'Vi Mô' }}
                  (bao gồm nhưng không giới hạn: thông tin của cá nhân tài trợ cho khách hàng là tổ
                  chức phi chính phủ, phi lợi nhuận; cá nhân chi phối/kiểm soát hoạt động tài khoản
                  của khách hàng; người thành lập, người đại diện pháp luật, thành viên ban điều
                  hành, kế toán trưởng của khách hàng…);
                </li>
                <li>
                  Các thông tin khác có liên quan, ảnh hưởng (trực tiếp/gián tiếp) hoặc phát
                  sinh/liên quan đến việc xác lập, cung cấp và đánh giá các hoạt động cung cấp Sản
                  Phẩm, Dịch Vụ, quan hệ lao động hoặc quan hệ pháp lý khác với Bên A phù hợp với
                  quy định pháp luật.
                </li>
              </ul>
            </li>
            <li>
              <b>“Xử lý dữ liệu cá nhân”</b> là một hoặc nhiều hoạt động tác động tới dữ liệu cá
              nhân, như: thu thập, ghi, phân tích, xác nhận, lưu trữ, chỉnh sửa, công khai, kết hợp,
              truy cập, truy xuất, thu hồi, mã hóa, giải mã, sao chép, chia sẻ, truyền đưa, cung
              cấp, chuyển giao, xóa, hủy dữ liệu cá nhân hoặc các hành động khác có liên quan.
            </li>
            <li>
              <b>“Bên Kiểm soát dữ liệu”</b> là tổ chức, cá nhân quyết định mục đích và phương tiện
              xử lý dữ liệu cá nhân.
            </li>
            <li>
              <b>“Bên Xử lý dữ liệu”</b> là tổ chức, cá nhân thực hiện việc xử lý dữ liệu thay mặt
              cho Bên Kiểm soát dữ liệu, thông qua một hợp đồng hoặc thỏa thuận với Bên Kiểm soát dữ
              liệu.
            </li>
            <li>
              <b>“Bên Kiểm soát và xử lý dữ liệu cá nhân”</b> là tổ chức, cá nhân đồng thời quyết
              định mục đích, phương tiện và trực tiếp xử lý dữ liệu cá nhân.
            </li>
            <li>
              <b>“Bên thứ ba”</b> là tổ chức, cá nhân ngoài Bên B, Bên Kiểm soát dữ liệu cá nhân,
              Bên Xử lý dữ liệu cá nhân, Bên Kiểm soát và xử lý dữ liệu cá nhân được phép xử lý dữ
              liệu cá nhân, bao gồm nhưng không giới hạn Bên Thứ Ba xử lý dữ liệu cá nhân thay mặt
              cho Bên xử lý dữ liệu, Bên thứ ba được phép Xử lý dữ liệu cá nhân với sự đồng ý của
              Bên B tại Điều khoản chung này hoặc các văn bản thỏa thuận với Bên B.
            </li>
            <li>
              <b>“Chuyển dữ liệu cá nhân ra nước ngoài”</b> là hoạt động sử dụng không gian mạng,
              thiết bị, phương tiện điện tử hoặc các hình thức khác chuyển dữ liệu cá nhân của công
              dân Việt Nam tới một địa điểm nằm ngoài lãnh thổ của nước Cộng hòa xã hội chủ nghĩa
              Việt Nam hoặc sử dụng một địa điểm nằm ngoài lãnh thổ của nước Cộng hòa xã hội chủ
              nghĩa Việt Nam để xử lý dữ liệu cá nhân của công dân Việt Nam, bao gồm:
              <ul>
                <li>
                  Tổ chức, doanh nghiệp, cá nhân chuyển dữ liệu cá nhân của công dân Việt Nam cho tổ
                  chức, doanh nghiệp, bộ phận quản lý ở nước ngoài để xử lý phù hợp với mục đích đã
                  được Bên B đồng ý;
                </li>
                <li>
                  Xử lý dữ liệu cá nhân của công dân Việt Nam bằng các hệ thống tự động nằm ngoài
                  lãnh thổ của nước Cộng hòa xã hội chủ nghĩa Việt Nam của Bên Kiểm soát dữ liệu cá
                  nhân, Bên Kiểm soát và xử lý dữ liệu cá nhân, Bên Xử lý dữ liệu cá nhân phù hợp
                  với mục đích đã được Bên B đồng ý.
                </li>
              </ul>
            </li>
            <li>
              Để làm rõ hơn, các từ ngữ nào chưa được giải thích tại Điều này sẽ được hiểu và áp
              dụng theo pháp luật Việt Nam.
            </li>
          </ol>
        </li>
        <li>
          <h1>THỎA THUẬN XỬ LÝ DỮ LIỆU CÁ NHÂN</h1>
          <p>Trong phạm vi nội dung và mục đích của phụ lục này:</p>
          <ol>
            <li>
              Với điều kiện tuân thủ các quy định khác trong Phụ lục này, Bên A được quyền xử lý dữ
              liệu và được quyền cung cấp dữ liệu cá nhân (do Bên B cho phép) cho Bên xử lý dữ liệu
              khác, Bên thứ ba hợp tác với Bên A xử lý dữ liệu nhằm phục vụ cho việc thực hiện Hợp
              đồng trừ trường hợp có sự thay đổi ý chí chủ quan của Bên B liên quan đến việc cho
              phép tiếp tục hoặc tạm dừng, hủy bỏ việc xử lý dữ liệu cá nhân. Bên xử lý dữ liệu
              khác, Bên thứ ba có trách nhiệm tuân thủ quy định Pháp luật về bảo vệ dữ liệu cá nhân
              và các nghĩa vụ khác theo Điều khoản và điều kiện chung, cùng Phụ lục này.
            </li>
            <li>
              Bên B cam đoan và bảo đảm rằng dữ liệu cá nhân và việc cung cấp dữ liệu cá nhân cho
              Bên A xử lý là hoàn toàn hợp pháp theo quy định của Pháp luật và thỏa thuận với Bên B
              cũng như các bên có liên quan.
            </li>
            <li>
              Bên A cam kết, bằng mọi nỗ lực cần thiết và hợp lý, xử lý dữ liệu cá nhân của Bên B
              một cách an toàn bảo mật và đảm bảo các quyền của Bên B tuân thủ theo quy định của
              pháp luật. Tuy nhiên, Internet và mạng lưới thông tin điện tử, môi trường công nghệ
              thông tin không phải là một môi trường an toàn tuyệt đối và việc truyền tải, chia sẻ
              dữ liệu có thể có các rủi ro tiềm ẩn, do đó Bên A không thể bảo đảm chắc chắn rằng các
              dữ liệu cá nhân của Bên B luôn được bảo mật một cách tuyệt đối tại mọi thời điểm. Bên
              A cam kết sẽ không trao đổi, cho thuê dữ liệu cá nhân của Bên B mà không có sự chấp
              thuận của Bên B hoặc thực hiện bán dữ liệu cá nhân dưới bất kỳ hình thức nào.
            </li>
            <li>
              {{
                checkCreatedDateNganluong(dataAppendix)
                  ? 'Trong những trường hợp đặc biệt được quy định chi tiết tại Điều 17 Nghị định 13/2023/NĐ - CP, Bên A có quyền xử lý dữ liệu cá nhân của Bên B mà không cần có sự đồng ý, chấp nhận từ Bên B.'
                  : 'Trong những trường hợp đặc biệt theo quy định pháp luật, Bên A có quyền xử lý dữ liệu cá nhân của Bên B mà không cần có sự đồng ý, chấp nhận từ Bên B.'
              }}
            </li>
            <li>
              Việc xử lý dữ liệu cá nhân bắt đầu kể từ thời điểm Bên A nhận được thông tin, dữ liệu
              cá nhân của Bên B. Bên A lưu trữ dữ liệu cá nhân của Bên B trong khoảng thời gian cần
              thiết để hoàn thành các mục đích theo Phụ lục này, trừ khi thời gian lưu trữ dữ liệu
              cá nhân lâu hơn được yêu cầu hoặc cho phép bởi các quy định pháp luật hiện hành.
            </li>
            <li>
              Dữ liệu cá nhân của Bên A cung cấp cho Bên B lưu trữ sẽ được bảo mật. Bên A sẽ thực
              hiện các biện pháp hợp lý để bảo vệ dữ liệu cá nhân của Bên B.
            </li>
            <li>
              Việc xử lý dữ liệu sẽ kết thúc theo thời hạn quy định trong Hợp đồng, thỏa thuận, văn
              bản hoặc thời hạn lưu trữ theo quy định tại Phụ lục này hoặc quy định pháp luật hiện
              hành.
            </li>
            <li>
              Trong trường hợp Bên B rút lại sự đồng ý của mình, yêu cầu xóa dữ liệu và/hoặc thực
              hiện các quyền có liên quan khác đối với bất kỳ hoặc tất cả các dữ liệu cá nhân của
              Bên B. Các hành vi được thực hiện bởi Bên B theo quy định này có thể ảnh hưởng đến khả
              năng tiếp tục cung cấp các sản phẩm, dịch vụ của Bên A cho Bên B, đồng thời Bên A bảo
              lưu các quyền và biện pháp khắc phục hợp pháp trong những trường hợp đó. Theo đó, Bên
              A sẽ không chịu trách nhiệm đối với Bên B cho bất kỳ tổn thất nào phát sinh, và các
              quyền hợp pháp của Bên A sẽ được bảo lưu một cách rõ ràng đối với việc giới hạn, hạn
              chế, tạm ngừng, hủy bỏ, ngăn cản việc xử lý dữ liệu của Bên B.
            </li>
            <li>
              Bên B có các: (i) Quyền được biết; (ii) Quyền đồng ý; (iii) Quyền truy cập; (iv) Quyền
              rút lại sự đồng ý; (v) Quyền xóa dữ liệu; (vi) Quyền hạn chế xử lý dữ liệu; (vii)
              Quyền cung cấp dữ liệu; (viii) Quyền phản đối xử lý dữ liệu; (ix) Quyền khiếu nại, tố
              cáo, khởi kiện; (x) Quyền yêu cầu bồi thường thiệt hại; (xi) Quyền tự bảo vệ và các
              quyền có liên quan khác theo quy định của pháp luật.
            </li>
            <li>
              Trong phạm vi pháp luật cho phép, Bên B có thể thực hiện các quyền của mình bằng cách
              liên hệ với Bên A theo thông tin được cung cấp chi tiết theo Hợp đồng hợp tác giữa Hai
              Bên.
            </li>
            <li>
              Vì mục đích bảo mật, Bên B có thể cần phải đưa ra yêu cầu của mình bằng văn bản hoặc
              sử dụng phương pháp khác để chứng minh và xác thực danh tính của Bên B. Bên A có thể
              yêu cầu Bên B xác minh danh tính trước khi xử lý yêu cầu của Bên B.
            </li>
            <li>
              Bên B cần thông báo ngay tới Bên A nếu phát hiện hoặc nghi ngờ Dữ Liệu Cá Nhân của bản
              thân bị lộ, có thể dẫn tới rủi ro trong quá trình sử dụng Sản Phẩm, Dịch Vụ tại Bên A
              hoặc bất kỳ vi phạm nào về bảo vệ Dữ Liệu Cá Nhân theo phụ lục này mà Bên B có thể
              nhận biết được;
            </li>
            <li>
              Bên B cam kết thường xuyên kiểm tra trên trang thông tin điện tử chính thức của Bên A
              để cập nhật và thực hiện theo bất kỳ thay đổi nào (nếu có) liên quan đến Phụ lục này;
            </li>
          </ol>
        </li>
        <li>
          <h1>MỤC ĐÍCH XỬ LÝ DỮ LIỆU CÁ NHÂN</h1>
          <ol>
            <li>
              Bên B đồng ý cung cấp, xác nhận Bên A và Bên thứ Ba mà Bên A hợp tác có thể xử lý dữ
              liệu cá nhân theo một hoặc nhiều các mục đích dưới đây:
              <ul>
                <li>
                  Đánh giá, xác định, xác minh hồ sơ pháp lý, tính chính xác, đầy đủ, tín dụng, tài
                  sản và khả năng đủ điều kiện của Bên B đối với bất kỳ Sản Phẩm, Dịch Vụ nào do Bên
                  A đề xuất hoặc cung cấp;
                </li>
                <li>
                  Nhận biết, xác minh và duy trì thông tin chính xác về nhận biết, xác thực, tìm
                  kiếm, xác minh và tiến hành các hoạt động kiểm tra về gian lận, phòng chống rửa
                  tiền, tài trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt (bao gồm nhưng
                  không giới hạn việc cung cấp thông tin cho các tổ chức tín dụng trong nước và
                  ngoài nước nhằm mục đích xử lý giao dịch cho Khách Hàng), thông tin giao dịch, tài
                  chính, tín dụng và các kiểm tra khác đối với Bên B theo yêu cầu;
                </li>
                <li>
                  Cân nhắc, phê duyệt việc cung cấp hoặc tiếp tục cung cấp bất kỳ Sản Phẩm, Dịch Vụ
                  theo các văn bản đăng ký, đề nghị, yêu cầu và các văn bản khác;
                </li>
                <li>
                  Thẩm định, xây dựng, đánh giá mức độ tin cậy trong việc sử dụng Sản Phẩm, Dịch Vụ;
                </li>
                <li>
                  Thực hiện các nghĩa vụ trong hợp đồng, phụ lục hợp đồng, thỏa thuận, điều khoản,
                  điều kiện và các văn bản khác giữa Các Bên.
                </li>
                <li>
                  Cho bất kỳ mục đích nào khác được yêu cầu hoặc cho phép bởi bất kỳ luật, quy định,
                  hướng dẫn và/hoặc các Cơ quan nhà nước có thẩm quyền;
                </li>
                <li>
                  Để phục vụ các mục đích khác có liên quan đến hoạt động kinh doanh của Bên A mà
                  Bên A cho là phù hợp tại từng thời điểm; và
                </li>
                <li>Các mục đích hợp lý khác có liên quan đến những mục đích được nêu trên.</li>
              </ul>
            </li>
            <li>
              Bên A sẽ yêu cầu sự cho phép từ Bên B trước khi sử dụng dữ liệu cá nhân của Bên B cho
              mục đích khác ngoài các mục đích đã được nêu tại Phụ lục và Điều khoản, điều kiện
              chung về Bảo vệ dữ liệu cá nhân.
            </li>
          </ol>
        </li>
        <li>
          <h1>CHUYỂN GIAO DỮ LIỆU CÁ NHÂN RA NƯỚC NGOÀI</h1>
          <ol>
            <li>
              Nhằm thực hiện mục đích xử lý dữ liệu cá nhân tại Phụ lục này, Bên A có thể phải cung
              cấp/chia sẻ dữ liệu cá nhân của Bên B đến các bên thứ ba liên quan của Bên A và các
              bên thứ ba này có thể tại Việt Nam hoặc bất cứ địa điểm nào khác nằm ngoài lãnh thổ
              Việt Nam.
            </li>
            <li>
              Khi thực hiện việc cung cấp/chia sẻ dữ liệu cá nhân ra nước ngoài, Bên A sẽ yêu cầu
              bên tiếp nhận đảm bảo rằng dữ liệu cá nhân của Bên B được chuyển giao cho họ sẽ bảo
              mật và an toàn. Bên A đảm bảo tuân thủ các nghĩa vụ pháp lý và quy định liên quan đến
              việc chuyển giao dữ liệu cá nhân của Bên B.
            </li>
          </ol>
        </li>
        <li>
          <h1>PHẠT VI PHẠM VÀ BỒI THƯỜNG THIỆT HẠI</h1>
          <ol>
            <li>
              Trường hợp một Bên vi phạm thỏa thuận tại Phụ lục này hoặc quy định pháp luật liên
              quan đến bảo vệ dữ liệu cá nhân, Bên vi phạm sẽ phải chịu phạt 8% giá trị nghĩa vụ vi
              phạm và theo đây đồng ý chịu trách nhiệm cho toàn bộ các khoản chi phí, thiệt hại thực
              tế và phải bồi thường toàn bộ thiệt hại mà Bên bị vi phạm phải gánh chịu, bao gồm: (i)
              thiệt hại về vật chất, tài sản; và (ii) thiệt hại về uy tín; và (iii) tất cả chi phí
              mà Bên bị vi phạm phải chịu để khắc phục hậu quả do hành vi vi phạm của Bên vi phạm.
            </li>
            <li>
              Ngoài ra, Bên vi phạm chịu hoàn toàn trách nhiệm trước cơ quan nhà nước và/hoặc Bên B
              nếu lỗi do Bên vi phạm gây ra và Bên bị vi phạm không có nghĩa vụ liên đới.
            </li>
          </ol>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ol>
            <li>
              Các Bên theo đây cam kết thực hiện việc bảo mật thông tin theo Thỏa thuận bảo mật đã
              được ký kết bởi hai bên. Trường hợp các Bên không ký kết Thỏa thuận bảo mật thì các
              Bên sẽ thực hiện nghĩa vụ bảo mật thông tin theo quy định tại Hợp đồng và quy định
              pháp luật.
            </li>
            <li>
              Bằng việc đăng ký tìm hiểu, đăng ký sử dụng, sử dụng các Sản Phẩm, Dịch Vụ, giao kết
              hợp đồng và/hoặc cung cấp Dữ Liệu Cá Nhân cho Bên A trên bất kỳ nền tảng nào và/hoặc
              dưới bất kỳ hình thức nào cho phép Bên A Xử Lý Dữ Liệu Cá Nhân, Bên B đã đọc, hiểu rõ,
              chấp nhận toàn bộ và không kèm theo bất kỳ điều kiện nào đối với các nội dung được đề
              cập tại Phụ lục này và tại Điều Khoản Chung được công bố trên
              <template v-if="!checkCreatedDateNganluong(dataAppendix)">website của Bên A</template>
              <template v-else>https://www.mpos.vn</template>
              và các thay đổi (nếu có) trong từng thời kỳ.
            </li>
            <li>
              Tất cả các quyền và nghĩa vụ của các Bên tại Phụ lục này sẽ không thay thế, chấm dứt
              hoặc thay đổi, mà sẽ là cộng dồn vào các quyền và nghĩa vụ mà Các Bên đang có ở bất kỳ
              văn bản nào đã thỏa thuận.
            </li>
            <li v-if="!checkCreatedDateNganluong(dataAppendix)">
              Phụ lục này là một phần không thể tách rời của Hợp đồng Hợp tác Chấp nhận thanh toán
              đã ký giữa Bên A và Bên B. Phụ lục được lập thành 02 (hai) bản bằng tiếng Việt có giá
              trị pháp lý như nhau. Mỗi Bên giữ 01 (một) bản để thực hiện. Nếu Phụ lục này được dịch
              ra các ngôn ngữ khác, bản tiếng Việt sẽ được ưu tiên áp dụng.
            </li>
            <li v-else>
              Phụ lục này được lập thành 02 (hai) bản bằng tiếng Việt có giá trị pháp lý như nhau.
              Mỗi Bên giữ 01 (một) bản để thực hiện. Nếu Phụ lục này được dịch ra các ngôn ngữ khác,
              bản tiếng Việt sẽ được ưu tiên áp dụng.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :isAppendix="true"
        :dataAppendix="dataAppendix"
      ></Footer>
      <FooterNL v-else :dataContract="dataContract" :isAppendix="true"></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixTrans.find(e => e.isCreatedWithContract)
        )
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
